module.exports = __webpack_public_path__ + "img/1.3b90d836.jpg";